'use client';

import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';

function SkeletonBlock({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-[10px] bg-gray-200 ${className}`} />;
}

export default function TermsSkeleton() {
  return (
    <DocumentPageShell title="Terms & Conditions">
      <div className="overflow-hidden rounded-2xl border border-[#e4e4e4] bg-white p-6 shadow-sm sm:p-8 md:p-10">
        <div className="mb-6 border-b border-[#f0f0f0] pb-6 sm:mb-8">
          <SkeletonBlock className="h-4 w-24" />
          <SkeletonBlock className="mt-2 h-6 w-40" />
        </div>
        <div className="space-y-10">
          {[0, 1, 2].map((i) => (
            <div key={i} className="space-y-3">
              <SkeletonBlock className="h-7 w-1/3" />
              <SkeletonBlock className="h-4 w-full" />
              <SkeletonBlock className="h-4 w-full" />
              <SkeletonBlock className="h-4 w-4/5" />
            </div>
          ))}
        </div>
      </div>
      <SkeletonBlock className="mt-6 h-28 rounded-2xl bg-red-200/60 sm:mt-8" />
    </DocumentPageShell>
  );
}
